import { useNotify as useRANotify } from "react-admin";

const useNotify = () => {
  const notify = useRANotify();

  const success = (message: string) =>
    //  { anchorOrigin: { vertical: 'top', horizontal: 'right' }
    notify(message, {
      type: "success",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const warning = (message: string) =>
    notify(message, {
      type: "warning",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const error = (message: string) =>
    notify(message, {
      type: "error",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const info = (message: string) =>
    notify(message, {
      type: "info",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });

  const successNotify = (message: string) =>
    notify(message, {
      type: "success",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const warningNotify = (message: string) =>
    notify(message, {
      type: "warning",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const errorNotify = (message: string) =>
    notify(message, {
      type: "error",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  const infoNotify = (message: string) =>
    notify(message, {
      type: "info",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });
  return {
    success,
    warning,
    error,
    info,
    successNotify,
    warningNotify,
    errorNotify,
    infoNotify,
  };
};

export default useNotify;
